module.exports = __webpack_public_path__ + "media/images/sp/articles/report_03-b902a4a48dc9b466597133609fe09ee9.webp";